// extracted by mini-css-extract-plugin
module.exports = {"familyImage":"FamilyDirectAccessImage_familyImage__Qk94O"};